require('./bootstrap');

// import jQuery from 'jquery';
// window.$ = jQuery;

$(document).ready(function () {

    $(".btn-reload").click(function (e) {
        e.preventDefault();
        location.reload();
    });

    $(".btn-close").click(function (e) {
        e.preventDefault();
        window.open('', '_blank', '').close();
        window.close();
    });

    $(document).on('keydown', 'input:visible, select:visible, .serial, .previous, .next, .modal-dialog', function(e) {
        var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
        if (key == 37) {
            var boto = $(this).closest('.container, .mycontainer').find('.previous');
            if (boto) {
                boto.click();
            }
        }
        else if (key == 39) {
            var boto = $(this).closest('.container, .mycontainer').find('.next');
            if (boto) {
                boto.click();
            }
        }
        else {
            if (key == 13) {
                var inputs = $(this).closest('.container, .mycontainer, .navigable').find(':input:visible, button, not:input[type="button"]');
                inputs.eq(inputs.index(this) + 1).focus();
                if (e.target.nodeName !== 'BUTTON') {
                    e.preventDefault();
                }
            }
        }
    });

    window.getdaysbetweendates = function (dia1, dia2) {
        dia1 = new Date(dia1);
        dia2 = new Date(dia2);
        var dif = dia2.getTime() - dia1.getTime();
        return Math.ceil(dif / (1000 * 3600 * 24))+1;
    }

    window.getTallas = function(action, token,  prdid, handledata) {
        // var action = "{{route('references.gettallas')}}";
        var data = {
            "_token": token,
            "prdid": prdid,
            "_method": "POST"
        }
        $.post (action, data, function (result) {
            handledata (result);
        }).fail(function (xhr, textStatus, errorThrown) {
            alert(xhr.responseText);
        });
    }

    window.getTiposhab = function(action, token, almid, handledata) {
        var data = {
            "_token": token,
            "almid": almid,
            "_method": "POST"
        }
        $.post (action, data, function (result) {
            handledata (result);
        }).fail(function (xhr, textStatus, errorThrown) {
            alert(xhr.responseText);
        });
    }

    window.getProductoStock = function(action, token,  prdid, handledata) {
        // var action = "{{route('references.gettallas')}}";
        var data = {
            "_token": token,
            "prdid": prdid,
            "_method": "POST"
        }
        $.post (action, data, function (result) {
            handledata (result);
        }).fail(function (xhr, textStatus, errorThrown) {
            alert(xhr.responseText);
        });
    }

    window.getFechasEvento = function (action, token, almid, handledata) {
        var action = action;
        var data = {
            "_token":token,
            "almid": almid,
            "_method": "POST"
        }
        $.post(action, data, function (result) {
            handledata (result);
        }).fail(function (xhr, textStatus, errorThrown) {
            // alert(xhr.responseText);
        });
    }

    // window.getPrecioProducto = function (datini, datfin, prdid, handledata) {
    //     var action = "{{route('productos.getpruprd')}}";
    //     var data = {
    //         "_token": "{{ csrf_token() }}",
    //         "empid": 2,
    //         "fromdate": datini,
    //         "todate": datfin,
    //         "prdid": prdid,
    //         "_method": "POST"
    //     }
    //     $.post(action, data, function (result) {
    //         handledata (result);
    //     }).fail(function (xhr, textStatus, errorThrown) {
    //         alert(xhr.responseText);
    //     });
    // }

});


